import { render } from "./VideoTag.vue?vue&type=template&id=66d74ce4"
import script from "./VideoTag.vue?vue&type=script&lang=js"
export * from "./VideoTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__